import React, {useEffect, useState} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import MyAccountMenu from "./MyAccountMenu/MyAccountMenu";
import GlobalConst from "../../constants/GlobalConst";
import {selectUserAccount, selectUserIsAuthenticated} from "../../stores/account/account.selectors";
import {useSelector} from "react-redux";
import useDeviceType from "../../hooks/useDeviceType";


import './MyAccountView.style.scss';
const MyAccountView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {isMobile, isTablet, isDesktop, screenType} = useDeviceType();
    const [currentView, setCurrentView] = useState('');

    const isUserAuthenticated = useSelector(selectUserIsAuthenticated);

    useEffect(() => {
        if (!isUserAuthenticated) {
            navigate('/lobby');
        }
    }, [isUserAuthenticated]);

    useEffect(() => {
        const path = extractPathSegment();
        setCurrentView(path);
    }, [location]);

    const extractPathSegment = () => {
        const paths = location.pathname.split('/');
        if (paths[1] === 'myaccount' && paths.length > 2) {
            return paths[2];
        }
        return null;
    };


    const handleNavigation = (path) => {
        navigate(`/myaccount/${path}`);
    };

    const handleRedirectMyAccountClick = (str) => {
        window.location.href = `${GlobalConst.SITE_URLS.TRADEFAN}/MyAccount/#${str}?pickx=1`;
    }

    const topBottomMargin = 80;
    const screenHeight = window.innerHeight - (topBottomMargin
                                                + GlobalConst.MEASUREMENT.DESKTOP.NAVIGATION_HEADER_HEIGHT);

    return (
        <div className="MyAccountView" >
            {isDesktop && <MyAccountMenu handleNavigation={handleNavigation}
                                         handleRedirectMyAccountClick={handleRedirectMyAccountClick}
                                         currentView={currentView}
                                         screenHeight={screenHeight}/>}
            <Outlet/>
        </div>
    );
};

export default MyAccountView;
